import { useEffect, useMemo } from 'react';

import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToMyTeamLevels, useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { IntentBreadcrumbType } from 'Deer/intent/types/IntentCommonTypes';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { checkLifecycleInsightsEnabled } from 'utils/helpers/featureFlags';

import { LifecycleInsightsIntentType, setSelectedLifecycleInsightsIntent } from '../slice/LifecycleInsightsIntentSlice';
import { MetaFiltersLifecycleInsights } from './MetaFiltersLifecycleInsights';

const LifecycleInsightsDropdown = ({
  showKebabMenu = true,
  breadcrumbs,
}: {
  showKebabMenu?: boolean;
  breadcrumbs: IntentBreadcrumbType;
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { l1Module } = useRouteToNavLevels();
  const { teamType } = useRouteToMyTeamLevels();

  const intentDropdownOptions = useMemo<Array<LifecycleInsightsIntentType>>(
    () => [
      {
        label: `Identifying ideal candidates`,
        onClick: () => {
          history.push({
            pathname: L3_PATHS.company.lifecycle.hire,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: L3_PATHS.company.lifecycle.hire,
            isAccessible: () => checkLifecycleInsightsEnabled(),
          },
        },
        category: 'HIRE',
      },
      {
        label: `Finding ideal mentors`,
        onClick: () => {
          history.push({
            pathname: L3_PATHS.company.lifecycle.onboard,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: L3_PATHS.company.lifecycle.onboard,
            isAccessible: () => checkLifecycleInsightsEnabled(),
          },
        },
        category: 'DEVELOP',
      },
      // {
      //   label: `Who are the best mentors for the new hires in my team?`,
      //   onClick: () => {
      //     history.push({
      //       pathname: L3_PATHS.company.lifecycle.hire,
      //     });
      //   },
      //   visible: () => true,
      //   value: {
      //     company: {
      //       path: L3_PATHS.company.lifecycle.hire,
      //       isAccessible: () => checkLifecycleInsightsEnabled(),
      //     },
      //   },
      //   category: 'DEVELOP',
      // },
      {
        label: `Recognizing promotion-ready talent`,
        onClick: () => {
          history.push({
            pathname: L3_PATHS.company.lifecycle.progress,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: L3_PATHS.company.lifecycle.progress,
            isAccessible: () => checkLifecycleInsightsEnabled(),
          },
        },
        category: 'PROGRESS',
      },
      {
        label: `Identifying flight-risk employees`,
        onClick: () => {
          history.push({
            pathname: L3_PATHS.company.lifecycle.retire,
          });
        },
        visible: () => true,
        value: {
          company: {
            path: L3_PATHS.company.lifecycle.retire,
            isAccessible: () => checkLifecycleInsightsEnabled(),
          },
        },
        category: 'RETIRE',
      },
      // {
      //   label: `Learning from voluntary leavers`,
      //   onClick: () => {
      //     history.push({
      //       pathname: L3_PATHS.company.lifecycle.retire,
      //     });
      //   },
      //   visible: () => true,
      //   value: {
      //     company: {
      //       path: L3_PATHS.company.lifecycle.retire,
      //       isAccessible: () => checkLifecycleInsightsEnabled(),
      //     },
      //   },
      //   category: 'RETIRE',
      // },
    ],
    // only history should be missing from the dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const selectedIntent = useMemo(
    () =>
      intentDropdownOptions.find((option) =>
        // const isTeamType = l1Module === 'team';
        // if (isTeamType) {
        //   return pathname.includes(option.value.team?.[teamType]?.path);
        // }
        pathname.includes(option.value[l1Module]?.path)
      ),
    [intentDropdownOptions, pathname, l1Module]
  );

  useEffect(() => {
    dispatch(setSelectedLifecycleInsightsIntent(selectedIntent));
  }, [selectedIntent, dispatch]);

  return (
    <IntentFilters
      intentDropdownOptions={intentDropdownOptions.filter((option) => option.visible())}
      selectedIntent={selectedIntent?.label ?? ''}
      selectedIntentCategory={selectedIntent?.category ?? ''}
      showCategory
      KebabMenu={null}
      MetaFilters={<MetaFiltersLifecycleInsights selectedIntent={selectedIntent} />}
      showKebabMenu={false}
      moduleName={null}
      intentTitle="Lifecycle insights"
      isCategorized
      breadcrumbs={breadcrumbs}
    />
  );
};

export { LifecycleInsightsDropdown };
